
import { Route } from 'react-router-dom';

import ManagerRoute from '../ManagerRoute';

import EmployeeDashboard from '../../features/dashboard/pages/EmployeeDashboard';
import EmployeeApplicationUsagePage from '../../features/dashboard/pages/EmployeeApplicationUsagePage';
import EmployeeLoggedHoursReport from '../../features/dashboard/pages/Employee/EmployeeLoggedHoursReport';
import EmployeeActiveHoursReport from '../../features/dashboard/pages/Employee/EmployeeActiveHoursReport';
import EmployeeIdleTimeReport from '../../features/dashboard/pages/Employee/EmployeeIdleTimeReport';
import EmployeeProductivityPage from '../../features/dashboard/pages/Employee/EmployeeProductivityPage';
import EmployeeCompliancePage from '../../features/dashboard/pages/Employee/EmployeeCompliancePage';

const EmployeeRoutes = () => {
  return (
    <>
      <Route
        path="/employee-dashboard"
        element={
          <ManagerRoute requiredRole="Employee">
            <EmployeeDashboard />
          </ManagerRoute>
        }
      />

      <Route
        path="/employee-application-usage"
        element={
          <ManagerRoute requiredRole="Employee">
            <EmployeeApplicationUsagePage />
          </ManagerRoute>
        }
      />

      <Route
        path="/employee-logged-hours-report"
        element={
          <ManagerRoute requiredRole="Employee">
            <EmployeeLoggedHoursReport />
          </ManagerRoute>
        }
      />

      <Route
        path="/employee-active-hours"
        element={
          <ManagerRoute requiredRole="Employee">
            <EmployeeActiveHoursReport />
          </ManagerRoute>
        }
      />

      <Route
        path="/employee-idle-time"
        element={
          <ManagerRoute requiredRole="Employee">
            <EmployeeIdleTimeReport />
          </ManagerRoute>
        }
      />

      <Route
        path="/emp-productivity-report"
        element={
          <ManagerRoute requiredRole="Employee">
            <EmployeeProductivityPage />
          </ManagerRoute>
        }
      />

      <Route
        path="/emp-compliance-report"
        element={
          <ManagerRoute requiredRole="Employee">
            <EmployeeCompliancePage />
          </ManagerRoute>
        }
      />
    </>
  );
};

export default EmployeeRoutes;
